import React, {
  useEffect,
  useState,
  useRef,
  useContext,
  Fragment,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Modal,
  Button,
  Tab,
  Row,
  Nav,
  Col,
  Form,
  InputGroup,
  FormControl,
  ListGroup,
  ProgressBar,
  OverlayTrigger,
  Tooltip,
} from "@themesberg/react-bootstrap";
import ReactDatatable from "@mkikets/react-datatable";
import { metodoPagoAction } from "../../actions/ventaActions";
import Swal from "sweetalert2";
import clienteAxios from "../../config/axios";
import { Toast } from "primereact/toast";
import { SocketContext } from "../../context/socket";
import { showModalAbonarAction } from "../../actions/abonosActions";

export default (props) => {
  const dispatch = useDispatch();
  const toast = useRef(null);
  const echo = useContext(SocketContext);

  const { totales, metodosPago } = useSelector(
    (state) => state.venta
  );

  const { showModalAbonar } = useSelector((state) => state.abonos);

  const { user } = useSelector((state) => state.auth);

  const [metodosPagoEdicion, guardar] = useState([
    {
      metodo_pago: null,
      id_metodo_pago: null,
      monto: 0,
      monto_recibido: 0,
      referencia: null,
      confirmando_cobro: false,
      eliminando_cobro: false,
      uuid_cobro: null,
      external_id_intencion_pago: null,
    },
  ]);
  const [catalogoMetodosPago, setCatalogoMetodosPago] = useState([]);
  const [datos, setDatos] = useState({
    cambio: 0,
    total_metodos: 0,
    metodos_sin_cobrar: 0,
    cantidad_metodos_pago: 0,
  });

  useEffect(() => {
    getMetodosPago();
  }, []);

  useEffect(() => {
    console.log(props.idCliente);
  }, [props.idCliente]);

  useEffect(() => {
    if (showModalAbonar === true) {
      guardar([
        {
          metodo_pago: null,
          id_metodo_pago: null,
          monto: 0,
          monto_recibido: 0,
          referencia: null,
        },
      ]);
      setDatos({
        total_metodos: 0,
        cambio: 0,
      });
    }
  }, [showModalAbonar]);

  const getMetodosPago = () => {
    clienteAxios.get("metodo-pago").then((respuesta) => {
      if (respuesta && respuesta.data.data && respuesta.data.success === true) {
        setCatalogoMetodosPago(
          respuesta.data.data.filter((metodo) => {
            return metodo.descripcion != null && metodo.descripcion !== "";
          })
        );
      }
    });
  };

  const getTotalMetodosPago = (incluirEfectivo = true) => {
    return metodosPagoEdicion.reduce((acc, item) => {
      return (
        acc +
        ((incluirEfectivo === false && item.metodo_pago === "EFECTIVO") ||
        item.metodo_pago === "FINANCIADO"
          ? 0
          : parseFloat(item.monto) || 0)
      );
    }, 0);
  };

  const handleClose = () => {
    dispatch(showModalAbonarAction(false));
  };

  const checarSiExisteMetodoFinanciado = () => {
    return (
      metodosPagoEdicion.filter((metodo) => metodo.metodo_pago == "FINANCIADO")
        .length > 0
    );
  };

  const submitForm = async (e) => {
    e.preventDefault();

    const totalMetodos = getTotalMetodosPago();

    if (
      checarSiExisteMetodoFinanciado() === false &&
      totalMetodos < parseFloat(totales.total)
    ) {
      Swal.fire(
        "¡UPS!",
        "El monto a recibir es menor al total de la venta",
        "error"
      );
    }

    dispatch(metodoPagoAction(metodosPagoEdicion));

    props.onSubmitForm(metodosPagoEdicion);
  };

  const cambio = () => {
    const totalMetodoEfectivo = getTotalEfectivo();
    const totalMetodosSinEfectivo = getTotalMetodosPago(false);

    const residual = totalMetodosSinEfectivo - totalMetodoEfectivo;
    if (residual >= 0) {
      return 0;
    }

    const total = parseFloat(totales.total);

    const cambio = (
      totalMetodoEfectivo -
      (total - totalMetodosSinEfectivo)
    ).toFixed(2);

    return isNaN(cambio) || cambio < 0 ? 0 : cambio;
  };

  const getTotalEfectivo = () => {
    return metodosPagoEdicion.reduce((acc, item) => {
      return (
        acc +
        (item.metodo_pago === "EFECTIVO" ? parseFloat(item.monto) || 0 : 0)
      );
    }, 0);
  };

  const onChangeForm = (e, index) => {
    if (e.target.name === "id_metodo_pago") {
      if (e.target.value == 0) {
        metodosPagoEdicion[index]["id_metodo_pago"] = null;
        metodosPagoEdicion[index]["metodo_pago"] = null;
        metodosPagoEdicion[index]["monto"] = 0;
      } else {
        metodosPagoEdicion[index]["metodo_pago"] = catalogoMetodosPago.find(
          (metodo) => metodo.id == e.target.value
        ).metodo;

        metodosPagoEdicion[index]["monto"] =
          metodosPagoEdicion[index]["metodo_pago"] == "FINANCIADO"
            ? totales.total
            : 0;
      }
    }

    metodosPagoEdicion[index][e.target.name] = e.target.value;

    if (e.target.name == "monto") {
      metodosPagoEdicion[index]["monto_recibido"] = e.target.value;
    }

    guardar(metodosPagoEdicion);
    recalcularDatos();
  };

  const recalcularDatos = () => {
    const totalMetodos = getTotalMetodosPago();
    const metodosSinCobrar = metodosPagoSinCobrar();
    const cantidadMetodos = cantidadMetodosPago();

    setDatos({
      ...datos,
      cambio: cambio(),
      total_metodos: totalMetodos,
      metodos_sin_cobrar: metodosSinCobrar,
      cantidad_metodos_pago: cantidadMetodos,
    });
  };

  const agregarMetodo = () => {
    if (metodosPagoEdicion.length == 2) {
      toast.current.show({
        severity: "error",
        summary: "No se puede agregar más de dos formas de pago",
        life: 2500,
      });
      return;
    }

    guardar([
      ...metodosPagoEdicion,
      { id_metodo_pago: null, monto: 0, referencia: null, metodo_pago: null },
    ]);
  };

  const cancelarCobro = (index) => {
    metodosPagoEdicion[index]["eliminando_cobro"] = true;

    const params = {
      uuid_cliente_cobro: metodosPagoEdicion[index]["uuid_cobro"],
      monto:
        metodosPagoEdicion[index]["metodo_pago"] == "EFECTIVO"
          ? metodosPagoEdicion[index]["monto"] - datos.cambio
          : parseFloat(metodosPagoEdicion[index]["monto"]),
    };

    clienteAxios
      .delete("clientes/cobro/" + metodosPagoEdicion[index]["uuid_cobro"], {
        params,
      })
      .then((respuesta) => {
        if (
          respuesta &&
          respuesta.data.success === true &&
          respuesta.status == 200
        ) {
          metodosPagoEdicion[index]["uuid_cobro"] = null;
          metodosPagoEdicion[index]["external_id_intencion_pago"] = null;
          metodosPagoEdicion[index]["confirmando_cobro"] = false;
        }

        metodosPagoEdicion[index]["eliminando_cobro"] = false;
        guardar(metodosPagoEdicion);
        recalcularDatos();
      })
      .catch((error) => {
        metodosPagoEdicion[index]["confirmando_cobro"] = false;
        metodosPagoEdicion[index]["eliminando_cobro"] = false;
        guardar(metodosPagoEdicion);
        recalcularDatos();
      });
  };

  const cobrar = (index) => {
    metodosPagoEdicion[index]["confirmando_cobro"] = true;

    let params = {
      id_cliente: props.idCliente,
      id_metodo_pago: parseInt(metodosPagoEdicion[index]["id_metodo_pago"]),
      monto:
        metodosPagoEdicion[index]["metodo_pago"] == "EFECTIVO"
          ? metodosPagoEdicion[index]["monto"] - datos.cambio
          : parseFloat(metodosPagoEdicion[index]["monto"]),
      monto_recibido: parseFloat(metodosPagoEdicion[index]["monto_recibido"]),
    };

    clienteAxios
      .post("venta/cobrar", params)
      .then((respuesta) => {
        if (
          respuesta &&
          respuesta.data.data &&
          respuesta.data.success === true &&
          respuesta.status == 200
        ) {
          metodosPagoEdicion[index]["uuid_cobro"] = respuesta.data.data;
        } else if (respuesta.status == 202) {
          metodosPagoEdicion[index]["external_id_intencion_pago"] =
            respuesta.data.data.external_id;

          echo
            .private(`AperturaCaja.${respuesta.data.data.id_apertura_caja}`)
            .listen(".cobro.exitoso", (data) => {
              const edicion = metodosPagoEdicion.map((obj) => {
                if (
                  obj["external_id_intencion_pago"] ==
                  data.params.external_id_intencion_pago
                ) {
                  obj["uuid_cobro"] = data.params.uuid_cobro;
                  return obj;
                }

                return obj;
              });

              guardar(edicion);
              recalcularDatos();
            })
            .listen(".cobro.fallido", (data) => {
              const edicion = metodosPagoEdicion.map((obj) => {
                if (
                  obj["external_id_intencion_pago"] ==
                  data.params.external_id_intencion_pago
                ) {
                  obj["external_id_intencion_pago"] = null;
                  obj["confirmando_cobro"] = false;
                  return obj;
                }

                return obj;
              });

              guardar(edicion);
              recalcularDatos();
            });
        }

        metodosPagoEdicion[index]["confirmando_cobro"] =
          respuesta.status == 202 ? true : false;
        guardar(metodosPagoEdicion);
        recalcularDatos();
      })
      .catch((error) => {
        metodosPagoEdicion[index]["confirmando_cobro"] = false;
        guardar(metodosPagoEdicion);
        recalcularDatos();
      });
  };

  const metodosPagoSinCobrar = () => {
    return metodosPagoEdicion.filter((metodoPago) => {
      return (
        (metodoPago["uuid_cobro"] == null ||
          metodoPago["uuid_cobro"] == undefined) &&
        metodoPago["metodo_pago"] != "EFECTIVO"
      );
    }).length;
  };

  const cantidadMetodosPago = () => {
    return metodosPagoEdicion.filter((metodoPago) => {
      return metodoPago["id_metodo_pago"] != null;
    }).length;
  };

  return (
    <>
      <Toast ref={toast} />
      <Modal
        as={Modal.Dialog}
        size="lg"
        centered
        show={showModalAbonar}
        onHide={handleClose}
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title className="h6">Métodos de pago</Modal.Title>
          <Button variant="close" aria-label="Close" onClick={handleClose} />
        </Modal.Header>
        <Form onSubmit={submitForm}>
          <Modal.Body className="shadow-sm">
            <Row className="text-right mb-2">
              <Col>
                <Button
                  variant="success"
                  type="button"
                  size="sm"
                  onClick={agregarMetodo}
                  //disabled={checarSiExisteMetodoFinanciado()}
                  disabled
                >
                  Agregar método de pago
                </Button>
              </Col>
            </Row>
            {metodosPagoEdicion.map((value, index) => {
              return (
                <>
                  <Row key={index}>
                    <Col md={3}>
                      <Form.Group className="mb-1">
                        <Form.Label>Forma de Pago*</Form.Label>
                        <Form.Select
                          name="id_metodo_pago"
                          onChange={(e) => onChangeForm(e, index)}
                          className="mb-2"
                          required
                          disabled={
                            metodosPagoEdicion[index]["uuid_cobro"] != null
                          }
                        >
                          <option value="0">
                            Selecciona una forma de pago
                          </option>
                          {catalogoMetodosPago.map((metodo) => {
                            return (
                              <option value={metodo.id}>
                                {metodo.descripcion}
                              </option>
                            );
                          })}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group className="mb-1">
                        <Form.Label>Monto recibido*</Form.Label>
                        <Form.Control
                          type="number"
                          name="monto"
                          required
                          onChange={(e) => onChangeForm(e, index)}
                          min={0}
                          disabled={
                            metodosPagoEdicion[index]["metodo_pago"] ==
                              "FINANCIADO" ||
                            metodosPagoEdicion[index]["uuid_cobro"] != null
                          }
                          value={
                            metodosPagoEdicion[index]["metodo_pago"] ==
                            "FINANCIADO"
                              ? totales.total
                              : metodosPagoEdicion[index]["monto"]
                          }
                        />
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group>
                        <Form.Label>Referencia</Form.Label>
                        <Form.Control
                          type="text"
                          name="referencia"
                          onChange={(e) => onChangeForm(e, index)}
                          disabled={
                            metodosPagoEdicion[index]["uuid_cobro"] != null
                          }
                        />
                      </Form.Group>
                    </Col>
                    <Col md={2}>
                      <Form.Label>Acción</Form.Label>
                      <br />
                      {metodosPagoEdicion[index]["uuid_cobro"] == null &&
                        metodosPagoEdicion[index]["metodo_pago"] !=
                          "EFECTIVO" && (
                          <Button
                            type="button"
                            variant="success"
                            size="sm"
                            onClick={() => {
                              cobrar(index);
                            }}
                            style={{ marginRight: "5px" }}
                            className="mt-1"
                            disabled={
                              metodosPagoEdicion[index]["confirmando_cobro"] ==
                                true ||
                              metodosPagoEdicion[index]["id_metodo_pago"] ==
                                null ||
                              metodosPagoEdicion[index]["monto"] == "" ||
                              metodosPagoEdicion[index]["monto"] == 0 ||
                              metodosPagoEdicion[index]["monto"] == undefined
                            }
                          >
                            Cobrar
                          </Button>
                        )}
                      {metodosPagoEdicion[index]["uuid_cobro"] != null && (
                        <Fragment>
                          <OverlayTrigger
                            trigger={["hover", "focus"]}
                            overlay={<Tooltip>Cancelar cobro</Tooltip>}
                          >
                            <Button
                              type="button"
                              variant="warning"
                              size="xs"
                              onClick={() => {
                                cancelarCobro(index);
                              }}
                              className="mt-1"
                            >
                              <i class="fas fa-window-close"></i>
                            </Button>
                          </OverlayTrigger>
                        </Fragment>
                      )}
                      <Button
                        type="button"
                        variant="danger"
                        size="sm"
                        onClick={() => {
                          metodosPagoEdicion.splice(index, 1);
                          recalcularDatos();
                        }}
                        className="mt-1"
                        disabled={
                          index === 0 ||
                          metodosPagoEdicion[index]["uuid_cobro"] != null
                        }
                      >
                        <i class="fas fa-trash"></i>
                      </Button>
                    </Col>
                  </Row>
                  {metodosPagoEdicion[index]["confirmando_cobro"] == true &&
                    metodosPagoEdicion[index]["uuid_cobro"] == null && (
                      <Row className="justify-content-center">
                        <Col xs={12}>
                          <ProgressBar
                            animated
                            now={100}
                            style={{ height: "50px" }}
                            label="Esperando confirmación de pago"
                            variant="default"
                          />
                        </Col>
                      </Row>
                    )}
                  {metodosPagoEdicion[index]["eliminando_cobro"] == true && (
                    <Row className="justify-content-center">
                      <Col xs={12}>
                        <ProgressBar
                          animated
                          now={100}
                          style={{ height: "50px" }}
                          label="Esperando confirmación de pago"
                          variant="default"
                        />
                      </Col>
                    </Row>
                  )}
                </>
              );
            })}
            <hr />
            <Row>
              <Col className="d-flex">
                <ListGroup className="my-2" style={{ width: "100%" }}>
                  <Row>
                    <Col sm={6}>
                      <ListGroup.Item
                        className="rounded-0"
                        style={{
                          backgroundColor: "rgb(16 141 175)",
                          color: "#fff",
                        }}
                      >
                        Total a pagar ($)
                      </ListGroup.Item>
                    </Col>
                    <Col sm={6}>
                      <InputGroup className="mb-3">
                        <Form.Control
                          className="rounded-0"
                          disabled
                          value={totales.total}
                        />
                      </InputGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={6}>
                      <ListGroup.Item
                        className="rounded-0"
                        style={{ backgroundColor: "#05A677", color: "#fff" }}
                      >
                        Monto pago ($)
                      </ListGroup.Item>
                    </Col>
                    <Col sm={6}>
                      <InputGroup className="mb-3">
                        <Form.Control
                          className="rounded-0"
                          disabled
                          value={datos.total_metodos}
                        />
                      </InputGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={6}>
                      <ListGroup.Item
                        className="rounded-0"
                        style={{
                          backgroundColor: "rgb(38, 43, 64)",
                          color: "#fff",
                        }}
                      >
                        Cambio ($)
                      </ListGroup.Item>
                    </Col>
                    <Col sm={6}>
                      <InputGroup className="mb-3">
                        <Form.Control
                          className="rounded-0"
                          disabled
                          value={datos.cambio}
                        />
                      </InputGroup>
                    </Col>
                  </Row>
                </ListGroup>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="link"
              className="text-gray ms-auto"
              onClick={handleClose}
            >
              Cerrar
            </Button>
            <Button
              type="submit"
              variant="secondary"
              disabled={
                datos.metodos_sin_cobrar > 0 || datos.cantidad_metodos_pago == 0
              }
            >
              Confirmar Pago
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};
